// components/PincodeInput.js
import './PincodeInput.css'; // Add this CSS file for custom styling
import { useEffect } from 'react';


const PincodeInput = ({ pincode, setPincode, validatePincode, error }) => {
  useEffect(() => {
    if (pincode.length === 6) {
      validatePincode();
    }
  }, [pincode, validatePincode]);

  return (
    <div className="pincode-container">
      <div className="pincode-card">
        <h2>PASSWORD</h2>
        <input
          type="password"
          value={pincode}
          onChange={(e) => setPincode(e.target.value)}
          placeholder="Enter your PIN"
          inputMode='numeric'
          pattern="[0-9]*"
          className="pincode-input"
        />
        <button onClick={validatePincode} className="pincode-button">Continue</button>
        {error && <p className="pincode-error">{error}</p>}
      </div>
    </div>
  );
};

export default PincodeInput;
